import NewOpportunity from "./components/NewOpportunityForm";

export default NewOpportunity